import { APP_ERROR, SET_APP_LOADING } from "../actions/types";

const initialState = {
    appLoading: false,
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_LOADING:
            return {
                ...state,
                appLoading: action.payload,
            };
        case APP_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};
export default appReducer;
